import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

const icon = css`
  margin-left: var(--space-75);
`;

const button = css`
  margin: var(--space-100) 0;
  border: none;

  --button-color: var(--text-primary);

  ${breakpoints.only.mobile} {
    margin: var(--space-100) var(--space-200) var(--space-100) 0;
  }

  &:hover svg path {
    stroke: var(--brand-dark);
  }
`;

const hidden = css`
  display: none !important;
`;

export { icon, button, hidden };
